import { Button, Modal } from "react-bootstrap"

const ConfirmationModal = ({confirmationModalShow, setShow, setisConfirmMessage, callback}) => {
    const confirmed = (e) => {
        e.preventDefault();
        callback(confirmationModalShow?.id)
        
    }
    
    const handleClose = () => {
        
        setShow({ show: false, text: null, id: null})
        
    }
    
    return(
        <Modal show={confirmationModalShow?.show} centered onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{confirmationModalShow?.title ?? 'Confirmation Message'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{confirmationModalShow?.text}</Modal.Body>
            <form onSubmit={confirmed}>
          <Modal.Footer className="gap-2">
            <button type="button" className="fs-12 m-0 integration-btns integration-btn-grey" onClick={handleClose}>
              Cancel
            </button>
            <button className="fs-12 shadow-none m-0  project-blue-btn " type="submit" autoFocus>
              Confirm
            </button>
          </Modal.Footer>
            </form>
        </Modal>

    )
}
export default ConfirmationModal